import styled from '@emotion/styled';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useAtomValue } from 'jotai';

import SidebarContents from './SidebarContents';
import SidebarHeader from './SidebarHeader';

function Sidebar() {
    const isOpen = useAtomValue(isSidebarOpenAtom);
    return (
        <Container isOpen={isOpen}>
            <SidebarHeader/>
            <SidebarContents/>
        </Container>
    );
}

const Container = styled.aside<{
    isOpen?: boolean;
}>`
    background-color: var(--color-white);
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    transform: ${({ isOpen }) => (isOpen
        ? 'none' : 'translateX(-100%)')};
    transition: 250ms ease-in-out;
    width: 100%;
    z-index: 2;
`;

export default Sidebar;
